/**
 * Environment Configuration Manager
 * All configuration is read from .env file
 * Update .env properties when deploying to different environments
 */

// Configuration loaded from .env
const ENV_CONFIG = {
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  cacheDuration: parseInt(process.env.REACT_APP_CACHE_DURATION) || 5 * 60 * 1000, // 5 minutes
  retryAttempts: parseInt(process.env.REACT_APP_API_RETRY_ATTEMPTS) || 3,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  debugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
  enableLogging: process.env.REACT_APP_ENABLE_LOGGING === 'true',
};

// Log current configuration (only in debug mode)
if (ENV_CONFIG.debugMode) {
  console.log(`🔧 Configuration loaded from .env`);
  console.log(`📡 API URL: ${ENV_CONFIG.baseUrl}`);
}

/**
 * Get environment configuration
 */
export const getEnvironmentConfig = () => ENV_CONFIG;

/**
 * Get specific config value
 */
export const getConfig = (key, defaultValue) => {
  return ENV_CONFIG[key] !== undefined ? ENV_CONFIG[key] : defaultValue;
};

export default ENV_CONFIG;
